import React, { useState, useRef } from 'react';
import { Printer, Download, ArrowLeft, Plus, Trash2 } from 'lucide-react';

const GRNPurchaseOrderForm = () => {
  const printRef = useRef();
  const [isPreviewMode, setIsPreviewMode] = useState(true);
  
  // Company and supplier data
  const [companyData] = useState({
    name: "Nissi Infotech",
    address: "3/42-12, Nagappa colony, kavundampalayam-636030, Tamil Nadu, India",
    phone: "Phone No: 9003744644",
    email: "Email: infraconsoft-implementation@nissiinfotech.in"
  });

  const [supplierData, setSupplierData] = useState({
    name: "AANCHAL ENTERPRISE",
    address: "12-MAHAVEER BHAWAN, A.T. ROAD,\nGUWAHATI - Assam,India",
    zipCode: "781001",
    phone: "",
    email: "",
    contactPerson: "Mr.-, Mr.-"
  });

  const [orderDetails, setOrderDetails] = useState({
    orderNo: "HEAD-OFFICE/OP/2023/0005",
    orderDate: "01/03/2023",
    purchaseRequestNo: "",
    quotationNo: "",
    quotationDate: "15/04/2023",
    gstin: "33AAGCS3528N1Z3"
  });

  const [items, setItems] = useState([
    {
      id: 1,
      sno: 1,
      description: "forestry cutter",
      hsnNo: "639",
      uom: "Nos",
      qty: 13.00,
      unitPrice: 200.00,
      amount: 2600.00,
      discount: 0.0,
      taxValue: 2600.00,
      totalAmount: 3068.00
    }
  ]);

  const [totals, setTotals] = useState({
    subTotal: 2600.00,
    discount: 0.00,
    afterDiscount: 2600.00,
    cgst: 234.00,
    sgst: 234.00,
    igst: 0.00,
    totalAmount: 3068.00,
    roundOff: 0.00,
    grandTotal: 3068.00
  });

  const [terms] = useState({
    price: "₹3,068.00 (Inclusive of All Taxes)",
    delivery: "On or Before 01/03/2023",
    freight: "nil",
    warranty: "-",
    payment: "nil",
    otherInstructions: "nil"
  });

  const addNewItem = () => {
    const newItem = {
      id: Date.now(),
      sno: items.length + 1,
      description: "",
      hsnNo: "",
      uom: "Nos",
      qty: 0,
      unitPrice: 0,
      amount: 0,
      discount: 0.0,
      taxValue: 0,
      totalAmount: 0
    };
    setItems([...items, newItem]);
  };

  const removeItem = (id) => {
    setItems(items.filter(item => item.id !== id));
  };

  const updateItem = (id, field, value) => {
    setItems(items.map(item => {
      if (item.id === id) {
        const updatedItem = { ...item, [field]: value };
        // Recalculate amounts
        if (field === 'qty' || field === 'unitPrice') {
          updatedItem.amount = updatedItem.qty * updatedItem.unitPrice;
          updatedItem.taxValue = updatedItem.amount;
          updatedItem.totalAmount = updatedItem.taxValue * 1.18; // Assuming 18% tax
        }
        return updatedItem;
      }
      return item;
    }));
  };

  const handlePrint = () => {
    window.print();
  };

  const handleDownload = () => {
    console.log("Download functionality would be implemented here");
  };

  const handleBack = () => {
    console.log("Navigate back");
  };

  return (
    <div className="min-h-screen bg-white print:bg-white">
      {/* Header Controls - Hidden in print */}
      <div className="print:hidden bg-gray-50 shadow-sm border-b p-4 no-print">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-between">
            <button
              onClick={handleBack}
              className="flex items-center gap-2 px-3 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded transition-colors"
            >
              <ArrowLeft size={18} />
              Back
            </button>
            <div className="flex items-center gap-2">
              <button
                onClick={addNewItem}
                className="flex items-center gap-2 px-3 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded text-sm transition-colors"
              >
                <Plus size={16} />
                Add Item
              </button>
              <button
                onClick={() => setIsPreviewMode(!isPreviewMode)}
                className="px-3 py-2 text-blue-600 hover:bg-blue-50 rounded text-sm transition-colors"
              >
                {isPreviewMode ? 'Edit Mode' : 'Preview Mode'}
              </button>
              <button
                onClick={handleDownload}
                className="flex items-center gap-2 px-3 py-2 bg-green-600 text-white hover:bg-green-700 rounded text-sm transition-colors"
              >
                <Download size={16} />
                PDF
              </button>
              <button
                onClick={handlePrint}
                className="flex items-center gap-2 px-3 py-2 bg-gray-800 text-white hover:bg-gray-900 rounded text-sm transition-colors"
              >
                <Printer size={16} />
                Print
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Print Content */}
      <div className="max-w-4xl mx-auto print:max-w-full print:mx-0 p-4 print:p-0">
        <div
          ref={printRef}
          className="bg-white print:bg-white border-2 border-black print:border-2 print:border-black"
        >
          {/* Header with Company Info and Logo */}
          <div className="border-b-2 border-black print:border-b-2 print:border-black">
            <div className="flex">
              {/* Logo Section */}
              <div className="w-24 border-r-2 border-black print:border-r-2 print:border-black flex items-center justify-center p-2">
                <div className="w-16 h-16 bg-gray-200 border border-gray-400 flex items-center justify-center">
                  <span className="text-xs font-bold text-center">LOGO</span>
                </div>
              </div>
              
              {/* Company Info */}
              <div className="flex-1 p-2">
                <div className="text-center">
                  <h1 className="text-lg font-bold">{companyData.name}</h1>
                  <p className="text-sm font-medium">Nissi</p>
                  <p className="text-xs">{companyData.address}</p>
                  <p className="text-xs">{companyData.phone}</p>
                  <p className="text-xs">{companyData.email}</p>
                </div>
              </div>
              
              {/* Purchase Order Title */}
              <div className="w-32 border-l-2 border-black print:border-l-2 print:border-black flex items-center justify-center p-2">
                <div className="text-center">
                  <h2 className="text-sm font-bold">Purchase</h2>
                  <h2 className="text-sm font-bold">Order</h2>
                </div>
              </div>
            </div>
          </div>

          {/* Supplier and Order Details */}
          <div className="flex border-b-2 border-black print:border-b-2 print:border-black">
            {/* Supplier Details */}
            <div className="w-1/2 border-r-2 border-black print:border-r-2 print:border-black p-2">
              <div className="border border-black p-2">
                <h3 className="text-sm font-bold mb-1">To</h3>
                <div className="text-xs space-y-1">
                  {isPreviewMode ? (
                    <>
                      <p className="font-bold">{supplierData.name}</p>
                      <p>{supplierData.address}</p>
                      <p>ZipCode - {supplierData.zipCode}</p>
                      <p>Phone:</p>
                      <p>Email:</p>
                      <p>Contact Person: {supplierData.contactPerson}</p>
                    </>
                  ) : (
                    <>
                      <input
                        type="text"
                        value={supplierData.name}
                        onChange={(e) => setSupplierData({...supplierData, name: e.target.value})}
                        className="w-full text-xs p-1 border border-gray-300 font-bold"
                        placeholder="Supplier Name"
                      />
                      <textarea
                        value={supplierData.address}
                        onChange={(e) => setSupplierData({...supplierData, address: e.target.value})}
                        className="w-full text-xs p-1 border border-gray-300"
                        rows="2"
                        placeholder="Address"
                      />
                      <input
                        type="text"
                        value={supplierData.zipCode}
                        onChange={(e) => setSupplierData({...supplierData, zipCode: e.target.value})}
                        className="w-full text-xs p-1 border border-gray-300"
                        placeholder="ZipCode"
                      />
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Order Details */}
            <div className="w-1/2 p-2">
              <table className="w-full text-xs border-collapse">
                <tbody>
                  <tr className="border-b border-black">
                    <td className="border-r border-black px-2 py-1 font-semibold">Order No :</td>
                    <td className="px-2 py-1">
                      {isPreviewMode ? (
                        orderDetails.orderNo
                      ) : (
                        <input
                          type="text"
                          value={orderDetails.orderNo}
                          onChange={(e) => setOrderDetails({...orderDetails, orderNo: e.target.value})}
                          className="w-full text-xs p-1 border border-gray-300"
                        />
                      )}
                    </td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="border-r border-black px-2 py-1 font-semibold">Order Date :</td>
                    <td className="px-2 py-1">
                      {isPreviewMode ? (
                        orderDetails.orderDate
                      ) : (
                        <input
                          type="date"
                          value={orderDetails.orderDate}
                          onChange={(e) => setOrderDetails({...orderDetails, orderDate: e.target.value})}
                          className="w-full text-xs p-1 border border-gray-300"
                        />
                      )}
                    </td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="border-r border-black px-2 py-1 font-semibold">Purchase Request No :</td>
                    <td className="px-2 py-1">
                      {isPreviewMode ? (
                        orderDetails.purchaseRequestNo
                      ) : (
                        <input
                          type="text"
                          value={orderDetails.purchaseRequestNo}
                          onChange={(e) => setOrderDetails({...orderDetails, purchaseRequestNo: e.target.value})}
                          className="w-full text-xs p-1 border border-gray-300"
                        />
                      )}
                    </td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="border-r border-black px-2 py-1 font-semibold">Quotation No :</td>
                    <td className="px-2 py-1">{orderDetails.quotationNo || "/"}</td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="border-r border-black px-2 py-1 font-semibold">Quotation Date :</td>
                    <td className="px-2 py-1">{orderDetails.quotationDate}</td>
                  </tr>
                  <tr>
                    <td className="border-r border-black px-2 py-1 font-semibold">GSTIN/UIN:</td>
                    <td className="px-2 py-1">{orderDetails.gstin}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Contact Message */}
          <div className="border-b border-black p-2">
            <p className="text-xs">Dear Sir, Please supply the following items subject to all items and conditions mentioned below</p>
          </div>

          {/* Items Table */}
          <div className="border-b-2 border-black">
            <table className="w-full border-collapse text-xs">
              <thead>
                <tr className="border-b border-black bg-gray-100">
                  <th className="border-r border-black px-1 py-1 text-center">S No</th>
                  <th className="border-r border-black px-1 py-1 text-left">Description</th>
                  <th className="border-r border-black px-1 py-1 text-center">HSN No</th>
                  <th className="border-r border-black px-1 py-1 text-center">UOM</th>
                  <th className="border-r border-black px-1 py-1 text-center">Qty</th>
                  <th className="border-r border-black px-1 py-1 text-center">Unit Price</th>
                  <th className="border-r border-black px-1 py-1 text-center">Amount</th>
                  <th className="border-r border-black px-1 py-1 text-center">Dis%</th>
                  <th className="border-r border-black px-1 py-1 text-center">Tax Value</th>
                  <th className="border-r border-black px-1 py-1 text-center">CGST%</th>
                  <th className="border-r border-black px-1 py-1 text-center">SGST%</th>
                  <th className="border-r border-black px-1 py-1 text-center">IGST%</th>
                  <th className="px-1 py-1 text-center">Total Amt</th>
                  {!isPreviewMode && <th className="print:hidden px-1 py-1 text-center">Action</th>}
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={item.id} className="border-b border-black">
                    <td className="border-r border-black px-1 py-1 text-center">{item.sno}</td>
                    <td className="border-r border-black px-1 py-1">
                      {isPreviewMode ? (
                        item.description
                      ) : (
                        <input
                          type="text"
                          value={item.description}
                          onChange={(e) => updateItem(item.id, 'description', e.target.value)}
                          className="w-full text-xs p-1 border border-gray-300"
                        />
                      )}
                    </td>
                    <td className="border-r border-black px-1 py-1 text-center">
                      {isPreviewMode ? (
                        item.hsnNo
                      ) : (
                        <input
                          type="text"
                          value={item.hsnNo}
                          onChange={(e) => updateItem(item.id, 'hsnNo', e.target.value)}
                          className="w-full text-xs p-1 border border-gray-300"
                        />
                      )}
                    </td>
                    <td className="border-r border-black px-1 py-1 text-center">{item.uom}</td>
                    <td className="border-r border-black px-1 py-1 text-center">
                      {isPreviewMode ? (
                        item.qty.toFixed(2)
                      ) : (
                        <input
                          type="number"
                          value={item.qty}
                          onChange={(e) => updateItem(item.id, 'qty', parseFloat(e.target.value))}
                          className="w-full text-xs p-1 border border-gray-300 text-center"
                        />
                      )}
                    </td>
                    <td className="border-r border-black px-1 py-1 text-center">
                      {isPreviewMode ? (
                        `₹${item.unitPrice.toFixed(2)}`
                      ) : (
                        <input
                          type="number"
                          value={item.unitPrice}
                          onChange={(e) => updateItem(item.id, 'unitPrice', parseFloat(e.target.value))}
                          className="w-full text-xs p-1 border border-gray-300 text-center"
                        />
                      )}
                    </td>
                    <td className="border-r border-black px-1 py-1 text-center">₹{item.amount.toFixed(2)}</td>
                    <td className="border-r border-black px-1 py-1 text-center">{item.discount}</td>
                    <td className="border-r border-black px-1 py-1 text-center">₹{item.taxValue.toFixed(2)}</td>
                    <td className="border-r border-black px-1 py-1 text-center">9.0</td>
                    <td className="border-r border-black px-1 py-1 text-center">9.0</td>
                    <td className="border-r border-black px-1 py-1 text-center">0.0</td>
                    <td className="px-1 py-1 text-center">₹{item.totalAmount.toFixed(2)}</td>
                    {!isPreviewMode && (
                      <td className="px-1 py-1 text-center print:hidden">
                        <button
                          onClick={() => removeItem(item.id)}
                          className="text-red-600 hover:text-red-800 p-1"
                        >
                          <Trash2 size={12} />
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Delivery Address and Totals */}
          <div className="flex border-b-2 border-black">
            {/* Delivery Address */}
            <div className="w-1/2 border-r-2 border-black p-2">
              <h3 className="text-sm font-bold mb-2">Delivery Address</h3>
              <div className="text-xs">
                <p className="font-bold">Rs Three Thousand Sixty-Eight Only</p>
              </div>
            </div>

            {/* Totals */}
            <div className="w-1/2 p-2">
              <table className="w-full text-xs border-collapse">
                <tbody>
                  <tr className="border-b border-black">
                    <td className="px-2 py-1">Sub Total:</td>
                    <td className="px-2 py-1 text-right">₹{totals.subTotal.toFixed(2)}</td>
                    <td className="px-2 py-1">Tot Amount:</td>
                    <td className="px-2 py-1 text-right">₹{totals.totalAmount.toFixed(2)}</td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="px-2 py-1">Discount:</td>
                    <td className="px-2 py-1 text-right">₹{totals.discount.toFixed(2)}</td>
                    <td className="px-2 py-1">PF / Others:</td>
                    <td className="px-2 py-1 text-right">₹0.00</td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="px-2 py-1">A.Dis Total:</td>
                    <td className="px-2 py-1 text-right">₹{totals.afterDiscount.toFixed(2)}</td>
                    <td className="px-2 py-1">Freight:</td>
                    <td className="px-2 py-1 text-right">₹0.00</td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="px-2 py-1">CGST:</td>
                    <td className="px-2 py-1 text-right">₹{totals.cgst.toFixed(2)}</td>
                    <td className="px-2 py-1">Insurance:</td>
                    <td className="px-2 py-1 text-right">₹0.00</td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="px-2 py-1">SGST:</td>
                    <td className="px-2 py-1 text-right">₹{totals.sgst.toFixed(2)}</td>
                    <td className="px-2 py-1">TCS(0.000%):</td>
                    <td className="px-2 py-1 text-right">₹0.00</td>
                  </tr>
                  <tr className="border-b border-black">
                    <td className="px-2 py-1">IGST:</td>
                    <td className="px-2 py-1 text-right">₹{totals.igst.toFixed(2)}</td>
                    <td className="px-2 py-1">Round Off (+/-):</td>
                    <td className="px-2 py-1 text-right">₹{totals.roundOff.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td className="px-2 py-1"></td>
                    <td className="px-2 py-1 text-right"></td>
                    <td className="px-2 py-1 font-bold">Grand Total:</td>
                    <td className="px-2 py-1 text-right font-bold">₹{totals.grandTotal.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Terms and Conditions */}
          <div className="border-b-2 border-black p-2">
            <div className="grid grid-cols-2 gap-4 text-xs">
              <div>
                <p><span className="font-bold">PRICE:</span> {terms.price}</p>
                <p><span className="font-bold">DELIVERY:</span> {terms.delivery}</p>
                <p><span className="font-bold">FREIGHT:</span> {terms.freight}</p>
              </div>
              <div>
                <p><span className="font-bold">WARRANTY:</span> {terms.warranty}</p>
                <p><span className="font-bold">PAYMENT:</span> {terms.payment}</p>
                <p><span className="font-bold">OTHER INSTRUCTIONS:</span> {terms.otherInstructions}</p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="flex justify-between items-center p-2 border-b border-black">
            <div className="text-xs">
              <p>Received and Accepted terms and conditions</p>
              <p className="mt-4">for SRC PROJECTS PRIVATE LIMITED</p>
            </div>
            <div className="text-xs text-right">
              <p>Authorized Signatory</p>
              <p className="mt-8">SLTNEW002</p>
              <p>01/03/2023 6:14AM</p>
            </div>
          </div>

          <div className="flex justify-between items-center p-2 text-xs">
            <div>
              <p>Authorized Signatory(With Seal)</p>
            </div>
            <div>
              <p>Page 1 of 1</p>
            </div>
          </div>

          <div className="text-center p-1 text-xs bg-gray-100">
            <p>Report generated by ERP-Software - www.infraconsoft.com owned by www.nissiinfotech.com</p>
          </div>
        </div>
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          @page {
            margin: 0.5in;
            size: A4;
          }
          
          .no-print {
            display: none !important;
          }
          
          body {
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
          }
          
          * {
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
          }
        }
      `}</style>
    </div>
  );
};

export default GRNPurchaseOrderForm;